import Button from "@components/atoms/button";
import theme from "@config/theme";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

import { VerticalActions } from "./dialog.styled";
import { DialogProps } from "./dialog.type";

const GenericDialog = ({
  open,
  title,
  content,
  onClose,
  onConfirm,
  confirmButtonText = "Confirm",
  cancelButtonText = "Cancel",
}: DialogProps) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle sx={{ fontFamily: "NotoSans-Regular", fontSize: "16px" }}>
      {title}
    </DialogTitle>
    <DialogContent>
      <DialogContentText
        sx={{ fontFamily: "NotoSans-Regular", fontSize: "12px" }}
      >
        {content}
      </DialogContentText>
    </DialogContent>
    <VerticalActions>
      <Button
        fontFamily="NotoSans-SemiBold"
        fontSize="14px"
        onClick={onConfirm}
        textColor={"#fff"}
        color="error"
        text={confirmButtonText}
        type="button"
      />
      <Button
        fontFamily="NotoSans-Medium"
        fontSize="14px"
        onClick={onClose}
        textColor={theme.palette.grey[900]}
        color="neutral"
        text={cancelButtonText}
        type="button"
      />
    </VerticalActions>
  </Dialog>
);

export { GenericDialog };
